import { actions } from "../../actions/action-list";
import initialState from "./initialState";

const Collections = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.FETCH_COLLECTION.FETCH_VEHICLE_WISE_COLLECTION:
      return { ...state, vehicleWiseCollection: action.value };
    case actions.FETCH_COLLECTION.FETCH_DAY_WISE_COLLECTION:
      return { ...state, dayWiseCollection: action.value };
    case actions.FETCH_COLLECTION.FETCH_COLLECTION_SUMMARY:
      return { ...state, collectionSummary: action.value };
    case actions.GROSS_CONTRIBUTION_UPLOAD_FAILURE:
      return { ...state, grossContributionUploadSheetError: action.value };
    default:
      return state;
  }
};
export default Collections;
